/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';

import { MyApp } from './app.component';

import {StatusBar} from '@ionic-native/status-bar';
import {SplashScreen} from '@ionic-native/splash-screen';
import {InAppBrowser} from '@ionic-native/in-app-browser';
import {AuthService} from "../providers/auth-service";
import {SessionService} from "../providers/session-service";
import {EventService} from "../providers/event-service";
import {FollowingService} from "../providers/following-service";
import {CompetitionService} from "../providers/competition-service";
import {ScheduleService} from "../providers/schedule-service";
import {ScheduleSplitCommunication} from "../providers/schedule-split-communication";
import {UserInterfacingService} from '../providers/user-interfacing-service/user-interfacing-service';
import {OneSignal} from "@ionic-native/onesignal";
import {DeviceUtilityService} from '../providers/device-utility-service/device-utility-service';
import { VotingServiceProvider } from '../providers/voting-service/voting-service';
import {firebaseConfig} from "../environments/firebase.config";
import {AngularFireModule} from "angularfire2";
import {AngularFireDatabase} from "angularfire2/database";
import {AngularFireAuth} from "angularfire2/auth";
import {InAppPurchase} from "@ionic-native/in-app-purchase";
import {Device} from "@ionic-native/device";
import {ThemeableBrowser} from "@ionic-native/themeable-browser";
import {QRCodeModule} from "angular2-qrcode";
import {Keyboard} from "@ionic-native/keyboard";
import { AnnouncementsProvider } from '../providers/announcements/announcements';
import { HelpProvider } from '../providers/help/help';
import {MediaStorageProvider} from "../providers/media-storage/media-storage";
import {CommunicationProvider} from "../providers/communication/communication";
import {ConnectionsProvider} from "../providers/connections/connections-service";
import {GroupsProvider} from "../providers/groups/groups";
import { UserServiceProvider } from '../providers/user-service/user-service';
import {ComponentsModule} from "../components/components.module";
import {ImageProvider} from "../providers/image/image";
import {Camera} from "@ionic-native/camera";

@NgModule({
  declarations: [
    MyApp
  ],
  imports: [
    BrowserModule,
    ComponentsModule,
    IonicModule.forRoot(MyApp, {
      mode: 'ios',
      tabsHideOnSubPages: true,
      preloadModules: true
    }),
    AngularFireModule.initializeApp(firebaseConfig),
    QRCodeModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp
  ],
  providers: [
    Device,
    Keyboard,
    StatusBar,
    SplashScreen,
    OneSignal,
    InAppPurchase,
    ThemeableBrowser,
    InAppBrowser,
    AuthService,
    DeviceUtilityService,
    SessionService,
    FollowingService,
    EventService,
    CompetitionService,
    AngularFireDatabase,
    AngularFireAuth,
    ScheduleService,
    ScheduleSplitCommunication,
    UserInterfacingService,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    VotingServiceProvider,
    AnnouncementsProvider,
    HelpProvider,
    MediaStorageProvider,
    CommunicationProvider,
    ConnectionsProvider,
    GroupsProvider,
    UserServiceProvider,
    ImageProvider,
    Camera,
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts